// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-bundle-" + {"149":"fd983525a1d6ba8d4268","224":"e798ec8d7aac621be29f","842":"9e1038dbb05908cf7fcb","891":"58659ea1b52f815a2258","933":"2349a2c81537e2a1cca6","997":"9221c5fdf0dd2c175e18"}[chunkId] + ".js";
};